var intval=() => {
	return parseInt.apply(console,arguments);
};
var floatval=() => {
	return parseFloat.apply(console,arguments);
};
var json_decode=() => {
	return JSON.parse.apply(console,arguments);
}
var json_encode=() => {
	return JSON.stringify.apply(console,arguments);
}
var explode = (selector, string) => {
	return string.toString().split(selector);
}
var implode = (selector, array) => {
	return array.join(selector);
}
var str_replace = (find,replace,string) => {
	if(typeof find == "array"){
		var temp="";
		find.forEach(function(toFind){
			if(temp==""){
				temp=string.toString();
			}
			temp=temp.replace(toFind,replace);
		});
		return temp;
	}
	return string.replace(find,replace);
}
var is_int = (val) => {
	if(parseInt(val) < parseFloat(val)){
		return false;
	}
	return true;
}
var is_float = (val) => {
	if(parseInt(val) < parseFloat(val)){
		return true;
	}
	return false;
}
var isset = (val) => {
	if((typeof val) !== "undefined"){
		return true;
	}
	return false;
}
var name_to_object= ($name) => {
	$switch = $name.toLocaleLowerCase();
	switch($switch){
		case "function":
			return Function;
		break;
		case "string":
			return String;
		break;
		case "object":
			return Object;
		break;
		case "array":
			return Array;
		break;
		default:
			if(isset(window[$name])){
				return window[$name];
			}else if(isset(document[$name])){
				return document[$name];
			}else {
				return null;
			}
		break;
	}
}
var instance_of = ($var, $class) => {
	var $origin=$class;
	if(typeof $class == "string"){
		$class=name_to_object($class);
	}
	if($class === null){
		console.warn("not implemented", $origin);
		return false;
	}
	if($var instanceof $class){
		return true;
	}
	return false;
}
export {intval, floatval, json_decode, json_encode, explode, implode, str_replace, instance_of, is_int, is_float, isset};